<template>
  <v-main>
    <router-view style="min-height: 80vh" />

    <DashboardCoreFooter />
  </v-main>
</template>

<script>
export default {
  name: 'DashboardCoreView',

  components: {
    DashboardCoreFooter: () => import('./Footer'),
  },
}
</script>
